// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zTzMF","select":"styles_select__1ETnN"};